export const MONTH_NAMES = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const iso = (d) => d.toLocaleDateString("sv-SE");

export const currentPeriod = () => { const n = new Date(); return { year: n.getFullYear(), month: n.getMonth() + 1 }; };
export const periodRange = ({ year, month }) => (!year ? [] : month ? [iso(new Date(year, month - 1, 1)), iso(new Date(year, month, 0))] : [`${year}-01-01`, `${year}-12-31`]);
export const periodLabel = ({ year, month }) => (!year ? "Tüm zamanlar" : month ? `${MONTH_NAMES[month - 1]} ${year}` : `${year} yılı`);

export function PeriodPicker({ value, onChange, testid = "period", allowAll = false }) {
  const y = new Date().getFullYear();
  return (
    <div className="report-toolbar period-picker" data-testid={`${testid}-picker`}>
      <span className="eyebrow" style={{ margin: 0 }}>YIL</span>
      <select data-testid={`${testid}-year-select`} value={value.year} onChange={(e) => onChange({ ...value, year: Number(e.target.value) })}>
        {allowAll && <option value={0}>Tüm zamanlar</option>}
        {Array.from({ length: allowAll ? 9 : 5 }, (_, i) => y + 1 - i).map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      {value.year > 0 && <>
        <span className="eyebrow" style={{ margin: "0 0 0 14px" }}>AY</span>
        <select data-testid={`${testid}-month-select`} value={value.month} onChange={(e) => onChange({ ...value, month: Number(e.target.value) })}>
          <option value={0}>Tüm aylar</option>
          {MONTH_NAMES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </select>
      </>}
    </div>
  );
}
